import { isMobile } from '../../../../application/typescript/utils/utils';

class CardAnnuaire {
  constructor() {
    this._init();
    this._listenCopy();
  }

  copyToClipboard(email: string) {
    navigator.clipboard.writeText(email).then(
      () => {
        console.log('Email copied to clipboard');
      },
      (err) => {
        console.error('Could not copy email to clipboard', err);
      }
    );
  }

  _listenCopy() {
    document.addEventListener('DOMContentLoaded', function () {
      const copyElements = document.querySelectorAll('[data-copy]');

      copyElements.forEach((element) => {
        element.addEventListener('click', function () {
          const textToCopy = element.getAttribute('data-copy');
          if (textToCopy) {
            navigator.clipboard.writeText(textToCopy);
          }
        });
      });
    });
  }

  _init() {
    const cards = document.querySelectorAll(`[data-trigger="card-secret"]`);

    if (isMobile()) {
      showPanel(cards);
    }

    window.addEventListener('resize', (e) => {
      const cards = document.querySelectorAll(`[data-trigger="card-secret"]`);
      if (isMobile()) {
        showPanel(cards);
      } else {
        removeDesktop(cards);
      }
    });

    function showPanel(cards) {
      cards.forEach(function (card) {
        if (card) {
          const panel = card.querySelector('.overlay-secret');
          // card.querySelector('.card-annuaire__secrets').addEventListener(
          //   'click',
          //   function (e) {
          //     e.preventDefault();
          //     e.stopPropagation();
          //     const panelElement = panel as HTMLElement;
          //     panelElement?.classList.toggle('card--open');

          //     const siblingElement = panelElement.parentElement?.querySelector(
          //       '.card-annuaire__secrets'
          //     ) as HTMLElement;

          //     siblingElement?.classList.toggle('card--open');
          //   },
          //   false
          // );

          card.querySelector('.card-annuaire__secrets').addEventListener(
            'touchstart',
            function (e) {
              e.preventDefault();
              e.stopPropagation(); // Évite des bugs d'événements multiples
              const panelElement = panel as HTMLElement;
              panelElement?.classList.toggle('card--open');

              const siblingElement = panelElement.parentElement?.querySelector(
                '.card-annuaire__secrets'
              ) as HTMLElement;

              siblingElement?.classList.toggle('card--open');
            },
            false
          );
        }
      });
    }

    function removeDesktop(cards) {
      cards.forEach(function (cardOpen) {
        const isOpen = cardOpen.querySelector('.card--open');
        if (isOpen) {
          (isOpen as HTMLElement)?.classList.remove('card--open');
        }
      });
    }
  }
}

export const cardAnnuaire = new CardAnnuaire();
